import React, { useMemo } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { SupportIssueStatusTypeConstants } from '@atlassian/cssxp-utils-support';

interface Props {
  status?: string | null;
}
const SupportIssueStatusLozengeFn = ({ status }: Props) => {
  const statusMap = useMemo(() => {
    const supportMap: any = {};
    SupportIssueStatusTypeConstants.forEach((statusType) => {
      supportMap[statusType.name] = statusType;
    });
    return supportMap;
  }, []);
  if (!status) {
    return <Lozenge appearance="default">N/A</Lozenge>;
  }
  if (status && !statusMap[status]) {
    return <Lozenge appearance="default">{status.toUpperCase()}</Lozenge>;
  }
  const currentAppearance = statusMap[status].type;
  return <Lozenge appearance={currentAppearance}>{status.toUpperCase()}</Lozenge>;
};
export default React.memo(SupportIssueStatusLozengeFn);
